import { ConsoleLogger } from "./forwarders/console-logger";
import { LogRouter } from "./log-router";
import { LogLevel } from "./types";

export let logger = new LogRouter(LogLevel.fatal, new ConsoleLogger(), new ConsoleLogger());

export function SetDefaultLogger(defaultLogger: LogRouter): void {
	logger = defaultLogger;
}
